import { tickerItems } from "../../../mocks/starTracker";

export default function Hero() {
  return (
    <section
      id="top"
      className="relative flex min-h-[520px] w-full flex-col justify-end overflow-hidden bg-foreground-950 md:min-h-[600px]"
    >
      <img
        src="https://readdy.ai/api/search-image?query=dark%20editorial%20newsroom%20silhouette%20with%20dramatic%20single%20spotlight%20beam%20through%20haze%2C%20warm%20amber%20and%20vermillion%20rim%20lighting%2C%20newspaper%20pages%20floating%2C%20cinematic%20moody%20atmosphere%2C%20high%20contrast%20textured&width=1800&height=900&seq=hero-bg&orientation=landscape"
        alt="编辑部聚光灯下的新闻素材与报纸剪影"
        className="absolute inset-0 h-full w-full object-cover object-top opacity-70"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/55 to-foreground-950/20"></div>
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/60 to-transparent"></div>

      <div className="relative mx-auto w-full max-w-[1200px] px-4 pb-16 pt-32 md:px-6 md:pb-20 lg:px-10">
        <div className="flex items-center gap-3">
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500/20 px-3 py-1 text-xs font-semibold text-accent-300 ring-1 ring-primary-400/40">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-400 opacity-75"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-400"></span>
            </span>
            编辑部 · 持续复盘更新
          </span>
        </div>

        <h1 className="mt-5 max-w-3xl font-heading text-3xl font-black leading-[1.2] text-background-50 md:text-5xl">
          明星婚变之后的每一步，<br className="hidden sm:block" />
          我们陪你看见<b className="text-accent-300">全貌</b>。
        </h1>

        <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-200/90 md:text-lg">
          离婚诉讼、公开回应、道歉、代言封杀与塌房反转——这些才是真正的“后续”。回声观察社以编辑视角，把这些进展串成可理解的时间线，帮你理性吃瓜、追瓜不迷路。
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
          <a
            href="#live"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("live")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-500"
          >
            <i className="ri-arrow-down-line text-base"></i>
            查看最新进展
          </a>
          <a
            href="#guide"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("guide")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50/10 px-6 py-3 text-sm font-semibold text-background-50 ring-1 ring-background-50/25 backdrop-blur transition-colors hover:bg-background-50/20"
          >
            如何理性追瓜
          </a>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-3">
          {[
            { icon: "ri-scales-3-line", num: "4 大", label: "程序性后续形态追踪" },
            { icon: "ri-empathize-line", num: "6 类", label: "传播与舆情关键节点" },
            { icon: "ri-shield-check-line", num: "持续", label: "事件信息核验与复盘" },
          ].map((s) => (
            <div
              key={s.label}
              className="flex items-center gap-3 rounded-lg bg-background-50/[0.06] px-4 py-3 ring-1 ring-background-50/10 backdrop-blur"
            >
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-500/20 text-accent-300">
                <i className={`${s.icon} text-lg`}></i>
              </span>
              <div>
                <p className="font-heading text-lg font-bold text-background-50">{s.num}</p>
                <p className="text-xs text-background-300/80">{s.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="relative border-t border-background-50/15 bg-foreground-950/80 backdrop-blur">
        <div className="mx-auto flex max-w-[1200px] items-center gap-4 overflow-hidden px-4 py-2.5 md:px-6 lg:px-10">
          <span className="flex shrink-0 items-center gap-1.5 whitespace-nowrap text-xs font-semibold text-accent-300">
            <i className="ri-flashlight-line text-sm"></i>
            今日关注
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="animate-[marquee_28s_linear_infinite] flex w-max items-center gap-10 whitespace-nowrap">
              {[...tickerItems, ...tickerItems].map((t, i) => (
                <span key={i} className="text-xs text-background-200/80">
                  <i className="ri-arrow-right-s-line text-accent-400"></i>
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
      <style>{`@keyframes marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }`}</style>
    </section>
  );
}